// Candidate property keys a mandal GeoJSON might use for the region name.
// Ordered by likelihood; first match wins.
const NAME_KEYS = ['MANDAL', 'mandal', 'Mandal', 'NAME', 'name', 'Name'] as const

/**
 * Canonical key for joining sites.mandal to a GeoJSON polygon name.
 * Lowercase, diacritic-free, punctuation-free, single-spaced.
 */
export function normalizeMandalName(value: string | null | undefined): string {
  if (!value) {
    return ''
  }
  return value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '') // strip diacritics (combining marks U+0300–U+036F)
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // strip punctuation
    .replace(/\s+/g, ' ')
    .trim()
}

/** Read a human-readable mandal name from a GeoJSON feature's properties. */
export function mandalNameOf(props: Record<string, unknown> | null | undefined): string | null {
  if (!props) {
    return null
  }
  for (const key of NAME_KEYS) {
    const v = props[key]
    if (typeof v === 'string' && v.trim().length > 0) {
      return v
    }
  }
  return null
}

/**
 * Display name for raw mandal dataset keys like "Turkapalle_M" / "Athmakur (M)".
 * The raw string remains the internal join key everywhere; only render through this.
 * Null-safe: unmapped/non-canonical sites can carry a null `mandal` at runtime (the
 * `string` type is a wire-contract lie), so a missing name renders as the "—" placeholder
 * rather than throwing `.replace` on null.
 */
export function prettyName(raw: string | null | undefined): string {
  if (!raw) {
    return '—'
  }
  return raw
    .replace(/_M$/, '')
    .replace(/\s*\(M\)\s*$/, '')
    .replace(/_/g, ' ')
    .trim()
}
